"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Skeleton = ({
  style,
  count,
  width,
  height,
  circle,
  duration,
  delay,
  iterations,
  color,
  ...otherProps
}) => {
  const getStyles = () => {
    let style = {};
    if (width !== undefined) style.width = isNaN(width) ? width : `${width}px`;
    if (height !== undefined) style.height = isNaN(height) ? height : `${height}px`;
    if (duration !== undefined) style.animationDuration = duration;
    if (delay !== undefined) style.animationDelay = delay;
    if (iterations !== undefined) style.animationIterationCount = !isNaN(iterations) ? parseInt(iterations) : iterations;
    if (color !== undefined) style.backgroundColor = color;
    style = { ...style,
      ...style
    };
    return Object.keys(style).length ? style : null;
  };

  const nodes = Array(count).fill();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: nodes.map((node, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SkeletonWrapper, {
      className: "rui-skeleton",
      role: "presentation",
      "aria-busy": "true",
      width: width,
      height: height,
      circle: circle,
      count: count,
      style: getStyles(),
      ...otherProps,
      children: "\u200C"
    }, index))
  });
};

Skeleton.propTypes = {
  count: _propTypes.default.number,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  circle: _propTypes.default.bool,
  duration: _propTypes.default.string,
  delay: _propTypes.default.string,
  iterations: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  color: _propTypes.default.string,
  contrast: _propTypes.default.bool
};
Skeleton.defaultProps = {
  count: 1,
  width: undefined,
  height: undefined,
  circle: false,
  duration: undefined,
  delay: undefined,
  iterations: undefined,
  color: undefined,
  contrast: undefined
};
var _default = Skeleton;
exports.default = _default;